export default __webpack_public_path__ + "static/default-10d395727808a69147aebf9ffd78fb87.png";